export default function HeroSection() {
  return (
    <section className="relative pt-32 pb-20 overflow-hidden bg-gradient-to-br from-slate-900 via-slate-800 to-teal-900">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
        backgroundSize: '50px 50px'
      }}></div>

      {/* Gradient Orbs */}
      <div className="absolute top-20 right-1/4 w-96 h-96 bg-teal-500/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center px-6 py-3 bg-white/10 backdrop-blur-md rounded-full mb-8">
            <i className="ri-building-line text-teal-400 text-xl mr-3"></i>
            <span className="text-white font-bold text-sm">M&A案件一覧</span>
          </div>

          {/* Title */}
          <h1 className="text-5xl md:text-6xl font-black text-white mb-6 leading-tight">
            稼働法人の
            <span className="bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent"> 譲渡案件</span>
          </h1>

          {/* Description */}
          <p className="text-xl text-gray-300 mb-12 leading-relaxed">
            実際に事業を行っている法人のM&A案件を掲載しています。<br />
            後継者不在、事業の選択と集中、ハッピーリタイアなど、様々な理由での譲渡案件がございます。
          </p>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-8 max-w-3xl mx-auto">
            {[
              { number: '12', label: '掲載案件数', icon: 'ri-file-list-3-line' },
              { number: '100+', label: '成約実績', icon: 'ri-checkbox-circle-line' },
              { number: '24h', label: '迅速対応', icon: 'ri-time-line' }
            ].map((stat, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <i className={`${stat.icon} text-3xl text-white`}></i>
                </div>
                <div className="text-4xl font-black text-white mb-2">{stat.number}</div>
                <div className="text-sm text-gray-400 font-bold">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
